<div class="blog-entry" >

  <div class="text-wrapper">
    <span class="title">{{entry?.title}}</span>
    <p class="text-body">{{entry?.text}}</p>
  </div>

  <div class="image-wrapper">
    <img [src]="entry?.image" [alt]="entry?.title"/>
  </div>

</div>
